import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { useQuery } from '@tanstack/react-query';

export const usePostRelayEpisodesQuery = ({ episodeIds }: { episodeIds: number[] }) =>
  useQuery({
    queryKey: relayQueryKey.episodeList(episodeIds),
    queryFn: () => RelayApi.episodes({ episodeIds }),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 10,
  });
